/**
 * Parses a pre-applied filter from URL search params.
 * Expects: ?filter=<URL-encoded JSON activeFilter object>
 * Returns the parsed filter object, or null if not present / invalid.
 */
export const parseFilterFromSearchParams = (searchString) => {
  const params = new URLSearchParams(searchString);
  const raw = params.get("filter");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

/**
 * Merges a URL filter into an activeFilters array.
 * Replaces any existing filter with the same filterId.
 */
export const mergeUrlFilterIntoActiveFilters = (activeFilters, urlFilter) => {
  if (!urlFilter) return activeFilters;
  const without = activeFilters.filter((f) => f.filterId !== urlFilter.filterId);
  return [...without, urlFilter];
};
